import {
	createExpandUpdate,
	createRemoveUpdate,
	type MosaicNode,
	type MosaicPath,
	updateTree,
} from "react-mosaic-component";
import ErrorHandler from "@/services/ErrorService/ErrorService";
import type { ViewId } from "@/shared/types/common";

export type ResizeWindowType = (
	state: MosaicNode<ViewId> | null,
	setState: (layout: MosaicNode<ViewId> | null) => void,
	path: MosaicPath,
	size: number,
) => void;

export const resizeWindow: ResizeWindowType = (state, setState, path, size) => {
	const updatedTree = updateTree(state as MosaicNode<ViewId>, [
		createExpandUpdate(path, size),
	]);
	setState(updatedTree as MosaicNode<ViewId>);
};

export type HandleCloseType = (
	state: MosaicNode<ViewId> | null,
	setState: (layout: MosaicNode<ViewId> | null) => void,
	path: MosaicPath,
) => void;

export const handleClose: HandleCloseType = (state, setState, path) => {
	if (state) {
		try {
			const updatedTree = updateTree(state, [createRemoveUpdate(state, path)]);
			if (!updatedTree || Object.keys(updatedTree).length === 0) {
				setState(null);
			} else {
				setState(updatedTree as MosaicNode<ViewId> | null);
			}
		} catch (error) {
			ErrorHandler.logError(error);

			setState(null);
		}
	}
};
